module.exports = __webpack_public_path__ + "static/img/icon_zylx03.f497ff23.png";